import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const MailFilled = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70">
      <g id="picto" transform="translate(-668 -150)">
        <circle id="bg" cx="35" cy="35" r="35" transform="translate(668 150)" fill="#27ae60"/>
        <g id="mail" transform="translate(687.01 173.008)">
          <path id="Tracé_437" data-name="Tracé 437" d="M5,4H28.983a3.007,3.007,0,0,1,3,3V24.987a3.007,3.007,0,0,1-3,3H5a3.007,3.007,0,0,1-3-3V7A3.007,3.007,0,0,1,5,4Z" transform="translate(-1 -3)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          <path id="Tracé_438" data-name="Tracé 438" d="M31.981,6,16.99,16.493,2,6" transform="translate(-1 -2.002)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default MailFilled;